"use strict";

import '../scss/index.scss';
import Navbar from './navbar';
import Swiper from '../vendor/swiper/js/swiper.min';

var navbar = new Navbar('navbar');

var swiper = document.getElementById('swiper');
if (swiper != null) {
    new Swiper('#swiper', {
        effect: 'fade',
        speed: 750,
        autoplay: { delay: 6500 }
    });
}

var referenceSwiper = document.getElementById('reference-swiper');
if (referenceSwiper != null) {
    new Swiper('#reference-swiper', {
        autoHeight: false,
        navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }
    });
}

if (module.hot) {
    module.hot.accept();
}